import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useStandardAction } from '../contexts/standards';

// One metadata/content form; callers choose fields and the documented API action.
export default function StandardEditor({ title, fields, initial, action, id, versionId, onSaved, onCancel }) {
    const [values, setValues] = useState(initial);
    const [failure, setFailure] = useState('');
    const [uncertain, setUncertain] = useState(false);
    const busy = useRef(false);
    const mutation = useStandardAction();
    async function submit(event) {
        event.preventDefault();
        if (busy.current || uncertain) return;
        busy.current = true; setFailure('');
        const payload = Object.fromEntries(fields.map(field => {
            let value = values[field.name] ?? '';
            if (typeof value === 'string') value = value.trim();
            if (field.type === 'number') value = Number(value);
            if (field.nullable && value === '') value = null;
            return [field.name, value];
        }));
        try {
            const saved = await mutation.mutateAsync({ action, id, versionId, payload });
            toast.success('Guardado y confirmado por Mastermind'); onSaved(saved);
        } catch (error) {
            setFailure([error.message, ...Object.values(error.fields ?? {})].filter(Boolean).join(' · '));
            setUncertain(error.requiresRefresh || error.isNetwork || error.isTimeout || error.status >= 500);
        } finally { busy.current = false; }
    }
    return <form className="standards-editor" onSubmit={submit} aria-label={title}>
        <h3>{title}</h3>
        <fieldset disabled={mutation.isPending || uncertain}>
            {fields.map(field => <label key={field.name}>{field.label}
                {field.options ? <select value={values[field.name] ?? ''} onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))}>
                    {field.options.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                </select> : field.type === 'textarea' ? <textarea rows={field.rows ?? 5} required={field.required} maxLength={field.maxLength}
                    value={values[field.name] ?? ''} onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))} />
                    : <input type={field.type ?? 'text'} required={field.required} min={field.min} minLength={field.minLength} maxLength={field.maxLength} pattern={field.pattern}
                        value={values[field.name] ?? ''} onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))} />}
                {field.help && <small>{field.help}</small>}
            </label>)}
        </fieldset>
        {failure && <p role="alert">{failure}</p>}
        {uncertain && <p>El resultado no está confirmado. Recarga y comprueba el registro antes de repetir la operación.</p>}
        <div className="standards__actions">
            <button type="submit" className="standards__primary" disabled={mutation.isPending || uncertain}>{mutation.isPending ? 'Guardando...' : 'Guardar'}</button>
            {onCancel && <button type="button" onClick={onCancel} disabled={mutation.isPending}>Cancelar</button>}
        </div>
    </form>;
}
